import { en, es } from './messages/index';
const settings = {
    merchantOrg: 'springbig',
    appTitle: 'SpringbigQA',
    cartWebviewUrl: 'https://springbig.com/',
    navType: 'stack',
    defaultScreen: 'Offers',
    images: {
        fullLogo: '',
        navLogo: ''
    },
    isContrast: true,
    hasCustomBackground: false,
    background: {
        light: '',
        dark: ''
    },
    firebase_project_id: 100,
    //fontFamily: 'Archivo SemiBold',
    profile: {
        profileIcon: false,
        hideInterests: true
    },
    redeemOfferInStore: true,
    redeemRewardInStore: true,
    upperLeftIcon: {
        toScreen: 'Profile',
        iconUrl: 'https://aemabitfolder.sfo2.cdn.digitaloceanspaces.com/icons8-adobe.svg'
    },
    bottomNav: [
        {
            toScreen: 'Rewards',
            i18n: 'navigation.rewards',
        },
        {
            toScreen: 'Offers',
            i18n: 'navigation.offers',
        },
        // {
        //     toScreen: 'SpringbigPay',
        //     i18n: 'navigation.springbigpay',
        // },
        {
            toScreen: 'Milestones',
            i18n: 'navigation.milestones',
        },
        {
            toScreen: 'Home',
            i18n: 'navigation.home',
        },
        {
            toScreen: 'Messages',
            i18n: 'navigation.messages',
        },
        {
            toScreen: 'Profile',
            i18n: 'navigation.profile',
        },
        {
            toScreen: 'Refer',
            i18n: 'navigation.refer',
        },
    ],
    sideNav: [
        {
            toScreen: 'LocationStore',
            i18n: 'navigation.select_store',
        },
        {
            toScreen: 'Rewards',
            i18n: 'navigation.rewards'
        },
        {
            toScreen: 'Offers',
            i18n: 'navigation.offers'
        },
        {
            toScreen: 'Milestones',
            i18n: 'navigation.milestones'
        },
        {
            toScreen: 'Messages',
            i18n: 'navigation.messages'
        },
        {
            toScreen: 'Profile',
            i18n: 'navigation.profile'
        },
        {
            toScreen: 'Refer',
            i18n: 'navigation.refer'
        },
    ],
    // customIcons: {
    //     Cart: 'https://springbig-mobile-app.s3.amazonaws.com/%APP_NAME%/svgs/cart.svg',
    //     BarMenu: 'https://springbig-mobile-app.s3.amazonaws.com/%APP_NAME%/svgs/menu.svg',
    //     Messages: 'https://springbig-mobile-app.s3.amazonaws.com/%APP_NAME%/svgs/messages.svg',
    //     Milestones: 'https://springbig-mobile-app.s3.amazonaws.com/%APP_NAME%/svgs/milestones.svg',
    //     Offers: 'https://springbig-mobile-app.s3.amazonaws.com/%APP_NAME%/svgs/offers.svg',
    //     Profile: 'https://springbig-mobile-app.s3.amazonaws.com/%APP_NAME%/svgs/profile.svg',
    //     Shared: 'https://springbig-mobile-app.s3.amazonaws.com/%APP_NAME%/svgs/refer.svg',
    //     Rewards: 'https://springbig-mobile-app.s3.amazonaws.com/%APP_NAME%/svgs/rewards.svg'
    //     GiftCardIcon: 'https://springbig-mobile-app.s3.amazonaws.com/%APP_NAME%/svgs/image.svg'
    // },
    expirationDateInDays: 30,
    languages: [
        {
            label: 'English (US)',
            i18n: en,
            default: true
        },
        {
            label: 'Spanish (ES)',
            i18n: es
        }
    ],
    switchLightDarkMode: true,
    titleOnTop: true,
    isMenu: true,
    disableLeftIcon: false,
    // forceColorMode: 'light',
    // screenBanners: [
    //     {
    //         screen: 'Rewards',
    //         bannerUrl: 'https://aemabitfolder.sfo2.cdn.digitaloceanspaces.com/b1.png'
    //     },
    //     {
    //         screen: 'Offers',
    //         bannerUrl: 'https://aemabitfolder.sfo2.cdn.digitaloceanspaces.com/b2.png'
    //     },
    //     {
    //         screen: 'Refer',
    //         bannerUrl: 'https://aemabitfolder.sfo2.cdn.digitaloceanspaces.com/b3.png'
    //     },
    //     {
    //         screen: 'ConvosContainer',
    //         bannerUrl: 'https://aemabitfolder.sfo2.cdn.digitaloceanspaces.com/b4.png'
    //     }
    // ],
    bottomTabsLength: 5,
    account: {
        notification: {
            hideEmailToggle: false,
        },
        disable_signature: {
            email: true,
            sms: false,
            loyalty: true,
        },
    },
    loyalty_wallet_opt_in: true,
    giftCardPresentAmounts: [15, 25, 35, 45, 55],
    pageHeaders: {
        'Milestones': {
            title: 'milestones.title',
            showBackButton: false,
            show: true
        },
        'Offers': {
            title: 'offers.available_offers',
            showBackButton: false,
            show: true
        },
        'Refer': {
            title: 'refer.title',
            showBackButton: true,
            show: false
        },
        'profile/menu': {
            title: 'profile.my_account',
            showBackButton: true,
            show: true
        },
        'profile/menu/history': {
            title: 'profileMenu.recent_history',
            showBackButton: true,
            show: true
        },
        'profile/menu/settings': {
            title: 'profileMenu.message_notifications',
            showBackButton: true,
            show: true
        },
        'profile/menu/account': {
            title: 'profileMenu.my_information',
            showBackButton: true,
            show: true
        },
        'Subscriptions': {
            title: 'subscriptions.title',
            showBackButton: false,
            show: true
        },
    },
    requireEmailVerficationGiftCard: true,
    showSubscriptionPrompt: true,
    hide_home_page: false
};
export default settings;
